module.exports = __webpack_public_path__ + "img/share_kakao.d0761002.png";